<div class="card">
    <div class="card-header border-0" *ngIf="showHeader !== undefined && showHeader === true">
        <div class="p-fluid justify-content-between">
            <h3 class="card-title">Fonte "Mobile App" {{titolo}}</h3>
            <div class="col-3 to-right" style="width: 100%;">
                <p-dropdown [options]="domande" optionLabel="topic" [(ngModel)]="selected"
                    dropdownIcon="fas fa-chevron-down" (ngModelChange)="dropdownChange($event)"
                    [autoDisplayFirst]="false"></p-dropdown>
            </div>
        </div>
    </div>
    <div class="card-body">
        <div #chart></div>
    </div>
</div>